module.exports = __webpack_public_path__ + "img/sunny.7bcc9c89.svg";